import {
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DossierDocumentsProvider,
    OrderDuplicateForm,
    useSelectedOrderContext,
} from '@europrocurement/l2d-modules';
import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { jsonLdIdScraper } from '@europrocurement/l2d-utils';
import {
    selectedPrescripteursSelector,
    useTiersService,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import { ParcoursFormaliteProvider } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { AnyAction } from '@reduxjs/toolkit';
import { useAppDispatch } from '../../../../redux/types';
import { DetailOrderHeader } from '../../components';

const OrderDuplicate: React.FunctionComponent = function () {
    const dispatch = useAppDispatch();
    const { order, dossiers } = useSelectedOrderContext();
    const { selectPrescripteur, selectSousClients } = useTiersService();
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);
    const { getSousClients, getPrescripteurs } = useTiersService();

    const [idsDossiers, setIdsDossiers] = useState<number[]>([]);
    const [hasDispatchPrescriber, setHasDispatchPrescriber] = useState(false);

    useEffect(() => {
        dispatch(getSousClients({}) as unknown as AnyAction);
        dispatch(getPrescripteurs({}) as unknown as AnyAction);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (order.id) {
            // Extract all dossiers ids related to the collection, to provide ids to the DossierDocumentsProvider
            const idDossiers = order?.dossiers
                ? order.dossiers
                      .map((dossier) => dossier.id)
                      .filter((id): id is number => id !== undefined)
                : [];

            setIdsDossiers(idDossiers);

            if (order?.client) {
                dispatch(selectSousClients({ id: jsonLdIdScraper(order.client) }));
            }
        }
    }, [dispatch, order, selectPrescripteur, selectSousClients]);

    // Dispatch order prescriber
    useEffect(() => {
        if (prescripteur && order && order.prescripteur) {
            const idPrescripteur = jsonLdIdScraper(order.prescripteur);

            if (prescripteur.id !== idPrescripteur) {
                dispatch(selectPrescripteur({ id: idPrescripteur }));
                dispatch({
                    type: 'sousClient/setmainFilter',
                    payload: {
                        key: 'prescripteurId',
                        value: idPrescripteur,
                    },
                });
                setHasDispatchPrescriber(true);
            } else {
                setHasDispatchPrescriber(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prescripteur, order, selectPrescripteur]);

    return (
        <DossierDocumentsProvider
            autoload
            dossierIds={idsDossiers}
        >
            {hasDispatchPrescriber && prescripteur && order.id && (
                <ParcoursFormaliteProvider
                    prescripteur={prescripteur}
                    back
                >
                    <DocumentPreviewProvider>
                        <Container maxWidth="lg">
                            <DetailOrderHeader displayDetailOrder={false} />
                            <OrderDuplicateForm
                                dossiers={dossiers}
                                collection={order}
                            />
                            <DocumentPreviewOverlay />
                        </Container>
                    </DocumentPreviewProvider>
                </ParcoursFormaliteProvider>
            )}
        </DossierDocumentsProvider>
    );
};

export default OrderDuplicate;
